(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-recommendation-tabs"] && !Shopify.designMode) return;
  try {
    /*
 * ProductRecommendationTabs — custom element powering the two-tab recommendation
 * slider component on the product page.
 *
 * Sliders are powered by keen-slider (loaded from CDN above the element).
 *
 * localStorage key: "recently-viewed-products"
 * Stored value: JSON array of { handle, title, url, image } — max 20 entries,
 *               newest first.
 */
class ProductRecommendationTabs extends HTMLElement {
  connectedCallback() {
    this._buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    this._panels  = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this._sliders = new Map(); /* trackEl -> keen-slider instance */

    this._buttons.forEach((btn) => {
      btn.addEventListener('click', () => this._activateTab(btn));
      btn.addEventListener('keydown', (e) => this._onKeydown(e));
    });

    this._recordCurrentProduct();
    this._loadRecentlyViewed();
    this._initCompleteLookSlider();
  }

  /* ── Tab activation ── */

  _activateTab(btn) {
    this._buttons.forEach((b) => {
      b.setAttribute('aria-selected', 'false');
      b.setAttribute('tabindex', '-1');
    });
    this._panels.forEach((p) => p.setAttribute('aria-hidden', 'true'));

    btn.setAttribute('aria-selected', 'true');
    btn.setAttribute('tabindex', '0');

    const panel = this.querySelector('#' + btn.getAttribute('aria-controls'));
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
      /* keen-slider mismeasures while display:none — recalc on tab show */
      const track = panel.querySelector('.keen-slider');
      const instance = track && this._sliders.get(track);
      if (instance) instance.update();
    }

    btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  _onKeydown(e) {
    const idx  = this._buttons.indexOf(e.currentTarget);
    let   next = -1;

    if      (e.key === 'ArrowRight') next = (idx + 1) % this._buttons.length;
    else if (e.key === 'ArrowLeft')  next = (idx - 1 + this._buttons.length) % this._buttons.length;
    else if (e.key === 'Home')       next = 0;
    else if (e.key === 'End')        next = this._buttons.length - 1;

    if (next >= 0) {
      e.preventDefault();
      this._activateTab(this._buttons[next]);
      this._buttons[next].focus();
    }
  }

  /* ── keen-slider readiness ── */

  _whenKeenReady(cb) {
    if (window.KeenSlider) { cb(); return; }
    const start = Date.now();
    const tick = () => {
      if (window.KeenSlider) { cb(); return; }
      if (Date.now() - start > 5000) return; /* give up after 5s */
      requestAnimationFrame(tick);
    };
    tick();
  }

  _buildSlider(trackEl, wrapperEl) {
    if (!trackEl || this._sliders.has(trackEl)) return;

    this._whenKeenReady(() => {
      const instance = new window.KeenSlider(trackEl, {
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 2,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 750px)': {
            slides: { perView: 4, spacing: 16 },
          },
        },
        created: (s) => this._updateArrows(s, wrapperEl),
        slideChanged: (s) => this._updateArrows(s, wrapperEl),
        updated: (s) => this._updateArrows(s, wrapperEl),
      });

      this._sliders.set(trackEl, instance);

      const prevBtn = wrapperEl && wrapperEl.querySelector('.product-rec-tabs__arrow--prev');
      const nextBtn = wrapperEl && wrapperEl.querySelector('.product-rec-tabs__arrow--next');
      if (prevBtn) prevBtn.addEventListener('click', () => instance.prev());
      if (nextBtn) nextBtn.addEventListener('click', () => instance.next());
    });
  }

  _updateArrows(slider, wrapperEl) {
    if (!wrapperEl) return;
    const prevBtn = wrapperEl.querySelector('.product-rec-tabs__arrow--prev');
    const nextBtn = wrapperEl.querySelector('.product-rec-tabs__arrow--next');
    if (!prevBtn || !nextBtn) return;

    const rel = slider.track.details.rel;
    const max = slider.track.details.maxIdx;

    /* Hide arrows entirely if all slides fit */
    if (max <= 0) {
      prevBtn.setAttribute('hidden', '');
      nextBtn.setAttribute('hidden', '');
      return;
    }

    if (rel <= 0) prevBtn.setAttribute('hidden', ''); else prevBtn.removeAttribute('hidden');
    if (rel >= max) nextBtn.setAttribute('hidden', ''); else nextBtn.removeAttribute('hidden');
  }

  /* ── Complete the Look slider ── */

  _initCompleteLookSlider() {
    const panel = this.querySelector('[id^="panel-complete-look-"]');
    if (!panel) return;

    const wrapper = panel.querySelector('.product-rec-tabs__slider-wrapper');

    const attach = () => {
      const track = panel.querySelector('.product-rec-tabs__slider');
      if (!track || this._sliders.has(track)) return;
      this._buildSlider(track, wrapper);
    };

    /* <product-recommendations> swaps its innerHTML after fetch */
    const observer = new MutationObserver(() => {
      if (panel.querySelector('.product-rec-tabs__slider')) {
        observer.disconnect();
        attach();
      }
    });
    observer.observe(panel, { childList: true, subtree: true });

    /* Try immediately in case content was server-rendered */
    attach();
  }

  /* ── Recently Viewed ── */

  _recordCurrentProduct() {
    const entry = {
      handle : this.dataset.productHandle,
      title  : this.dataset.productTitle,
      url    : this.dataset.productUrl,
      image  : this.dataset.productImage,
    };
    if (!entry.handle) return;

    const KEY = 'recently-viewed-products';
    const MAX = 20;

    let history = [];
    try { history = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}

    history = history.filter((p) => p.handle !== entry.handle);
    history.unshift(entry);
    if (history.length > MAX) history = history.slice(0, MAX);

    try { localStorage.setItem(KEY, JSON.stringify(history)); } catch (_) {}
  }

  _loadRecentlyViewed() {
    const KEY = 'recently-viewed-products';
    const currentHandle = this.dataset.productHandle;
    const container = this.querySelector('.product-rec-tabs__recently-viewed-content');
    if (!container) return;

    let history = [];
    try { history = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}

    const products = history.filter((p) => p.handle !== currentHandle);

    if (!products.length) {
      container.innerHTML = '<p class="product-rec-tabs__empty">You haven\'t viewed any other products yet.</p>';
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'product-rec-tabs__slider-wrapper';

    const prevBtn = this._createArrowBtn('prev');
    const nextBtn = this._createArrowBtn('next');

    const track = document.createElement('div');
    track.className = 'product-rec-tabs__slider keen-slider';

    products.forEach((p) => {
      const slide = document.createElement('div');
      slide.className = 'product-rec-tabs__slide keen-slider__slide';
      slide.innerHTML = `
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media">
            <div class="card__inner ratio" style="--ratio-percent: 100%;">
              <div class="card__media">
                <div class="media media--transparent">
                  <a href="${p.url}" aria-label="${p.title}">
                    ${p.image
                      ? `<img src="${p.image}" alt="${p.title}" loading="lazy" width="400" height="400" style="width:100%;height:100%;object-fit:cover;">`
                      : `<div style="width:100%;height:100%;background:#f2f2f2;"></div>`}
                  </a>
                </div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${p.url}" class="full-unstyled-link">${p.title}</a>
                </h3>
              </div>
            </div>
          </div>
        </div>`;
      track.appendChild(slide);
    });

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(track);
    wrapper.appendChild(nextBtn);

    container.innerHTML = '';
    container.appendChild(wrapper);

    this._buildSlider(track, wrapper);
  }

  _createArrowBtn(direction) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `product-rec-tabs__arrow product-rec-tabs__arrow--${direction}`;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Previous products' : 'Next products');
    btn.setAttribute('hidden', '');
    btn.innerHTML = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="${direction === 'prev' ? 'M17.8424 24.6188L9.20242 15.4688C8.93242 15.1838 8.93242 14.7338 9.20242 14.4338L17.8574 5.23877' : 'M11.265 24.6188L19.905 15.4688C20.175 15.1838 20.175 14.7338 19.905 14.4338L11.25 5.23877'}" stroke="#222222" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    return btn;
  }
}

customElements.define('product-recommendation-tabs', ProductRecommendationTabs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-tabs"] && !Shopify.designMode) return;
  try {
    class ProductTabs extends HTMLElement {
  connectedCallback() {
    this._bindTabs();

    /* Dawn's product-info only swaps price/sku/inventory on variant change.
       Subscribe to the variantChange event so variant-scoped metafields
       (e.g. custom.detail per metal) refresh their tab panel too. */
    this._variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!event.data || !event.data.html) return;
      const fresh = event.data.html.getElementById(this.id);
      if (!fresh) return;
      this.innerHTML = fresh.innerHTML;
      this._bindTabs();
    });
  }

  disconnectedCallback() {
    if (this._variantUnsub) this._variantUnsub();
  }

  _bindTabs() {
    this._buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    this._panels  = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this._buttons.forEach((btn) => {
      btn.addEventListener('click', () => this._activate(btn));
      btn.addEventListener('keydown', (e) => this._onKeydown(e));
    });
  }

  _activate(btn) {
    this._buttons.forEach((b) => {
      b.setAttribute('aria-selected', 'false');
      b.setAttribute('tabindex', '-1');
    });
    this._panels.forEach((p) => p.setAttribute('aria-hidden', 'true'));

    btn.setAttribute('aria-selected', 'true');
    btn.setAttribute('tabindex', '0');

    const panelId = btn.getAttribute('aria-controls');
    const panel = this.querySelector('#' + panelId);
    if (panel) panel.setAttribute('aria-hidden', 'false');

    /* Scroll the clicked tab into view (handles mobile overflow) */
    btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  _onKeydown(e) {
    const idx = this._buttons.indexOf(e.currentTarget);
    let next = -1;

    if (e.key === 'ArrowRight') next = (idx + 1) % this._buttons.length;
    else if (e.key === 'ArrowLeft') next = (idx - 1 + this._buttons.length) % this._buttons.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = this._buttons.length - 1;

    if (next >= 0) {
      e.preventDefault();
      this._activate(this._buttons[next]);
      this._buttons[next].focus();
    }
  }
}

customElements.define('product-tabs', ProductTabs);
  } catch(e) { console.error(e); }
})();

})();
